import { API_BASE_URL } from "./config";
import { authHeader } from "./auth";

export function request(path, init) {
    var url = API_BASE_URL + path;

    var defaults = {
        method: "GET",
        headers: { "Accept": "application/json" }
    };

    var options = Object.assign({}, defaults, init || {});
    options.headers = Object.assign({}, defaults.headers, authHeader(), (init && init.headers) || {});

    return fetch(url, options).then(function (res) {
        var ct = res.headers.get("content-type") || "";

        if (!res.ok) {
            // prečítaj text, nech vidíme dôvod 500
            return res.text().then(function (txt) {
                var msg = "HTTP " + res.status + (txt ? (": " + txt) : "");
                var err = new Error(msg);
                err.status = res.status;
                throw err;
            });
        }

        if (ct.indexOf("application/json") !== -1) { return res.json(); }
        return res.text();
    });
}
